import util from '../util'

let controller = 'ImportaArquivos'
export default {
  Get: function (id) {
    return util.Axios.Get(controller, id)
  },
  GetAll: function (dto) {
    return util.Axios.GetAll(controller, dto)
  },
  Post: function (dto) {
    return util.Axios.PostForm(controller, dto)
  },
  Put: function (id, dto) {
    return util.Axios.Put(controller, id, dto)
  },
  Delete: function (id) {
    return util.Axios.Delete(controller, id)
  },
  Alerta: function (file) {
    console.log(file)
  },
  PostCNAB: function (dto) {
    return util.Axios.PostForm(controller + '/PostImportaArquivoCNAB', dto)
  },
}